class cOptionsMEMSOTheme {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elBtnSaveMEMSOThemeOptions = $("#save-memso-theme-options-btn");
        var elBtnSaveMEMSOThemeOptionsTop = $("#save-memso-theme-options-top-btn");
        this.elSelectGoogleFont = $("#memso-theme-font-sel");
        this.elInputGoogleFont = $("#memso-theme-font-inpt");
        this.elMEMSOThemeOptionsEditFrom = $('#memso-theme-options-form');
        this.elBackgroundImgInput = $('#background-image-input');
        $(this.elBackgroundImgInput).change(function (e) { return self.onFileChangeCheckSize(this, e); });
        $(elBtnSaveMEMSOThemeOptions).click(function (e) { return self.onBtnSaveMEMSOThemeOptionsClick(this, e); });
        $(elBtnSaveMEMSOThemeOptionsTop).click(function (e) { return self.onBtnSaveMEMSOThemeOptionsClick(this, e); });
        $(this.elSelectGoogleFont).change(function (e) { return self.onSelectGoogleFontChange(this, e); });
        this.syncGoogleFontFields();
        $('.preview-theme-changes-btn').click(function () { return self.previewThemeChanges(this); });
    }
    syncGoogleFontFields() {
        if (this.elSelectGoogleFont.length && this.elInputGoogleFont.length) {
            if (this.elSelectGoogleFont.val()) {
                this.elInputGoogleFont.val('').attr('disabled', 'disabled');
            } else {
                this.elInputGoogleFont.removeAttr('disabled');
            }
        }
    }
    previewThemeChanges(button) {
        $(button).button('loading');
        $(this.elMEMSOThemeOptionsEditFrom).ajaxSubmit({
            url: URL_ADMIN + '/sourcesdb/savethemepreview/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    var win = window.open($(button).data('sources-url') + '?pid=' + response.data.preview_id, '_blank');
                    if (win) {
                        //Browser has allowed it to be opened
                        win.focus();
                    }
                    else {
                        //Browser has blocked it
                        alert('Please allow popups for this website');
                    }
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(button).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, button);
            },
        });
        return false;
    }
    onBtnSaveMEMSOThemeOptionsClick(btn, e) {
        var self = this;
        $(btn).button('loading');
        $(this.elMEMSOThemeOptionsEditFrom).ajaxSubmit({
            url: URL_ADMIN + '/sourcesdb/updatememsotheme/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
    }
    onSelectGoogleFontChange(select, e) {
        this.syncGoogleFontFields();
    }
    onFileChangeCheckSize(input, e) {
        if (input.files[0].size > 500000) {
            notify.error(input.files[0].name + " exceeds 500kb maximum. Please choose a smaller file.");
            input.value = '';
        }
        return;
    }
}
